import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../style/ProjectGallery.css";
import img1 from "../assets/images/iso-view-1.png";
import img2 from "../assets/images/iso-view-2.png";
import img3 from "../assets/images/iso-view-3.png";
import img4 from "../assets/images/iso-view-4.jpeg";
import { useNavigate } from "react-router-dom";

const images = [img1, img2, img3, img4];

const ProjectGallery = () => {
  useEffect(() => {
        AOS.init();
      }, [])
  const navigate = useNavigate();
  return (
    <div className="gallery-container">
      <h2 className="gallery-title">
        PROJECTS WE HAVE UNDERTAKEN AROUND <span>THE WORLD</span>
      </h2>
      <p className="gallery-subtitle">
        A selection of the steel detailing work we have undertaken for complex
        structures
      </p>
      <div className="gallery">
        {images.map((src, index) => (
          <div key={index} className="gallery-item" onClick={ ()=> navigate("/sampledrawings")} data-aos="zoom-out-down" data-aos-duration="1000">
            <img src={src} alt={`Project ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectGallery;
